// extracted by mini-css-extract-plugin
module.exports = {"linkGroup":"antd-pro-pages-dashboard-workplace-components-editable-link-group-index-linkGroup"};